<jw-modal id="transportAllOrdersModal">

    <h1>Search orders</h1>
    <app-grid
    entity='order'
    [filters]='this.filters'
    [columns]='this.columns'
    [buttons]='this.buttons'
    [searchFilters]='this.searchFilters'
    [searchFields]='this.searchFields'
    [relationships]='["tipSite"]'
    ></app-grid>
    <button class='btn btn-danger' (click)='this.cancel()'>Close</button>
</jw-modal>
